<template>
    <div class="my-border">
        <div v-for="(slots, date) in data.schedule" style="margin-bottom: 8px" :key="date">
            <div v-if="hasPrivateMeetings(slots)">
                <template v-if="data.client.isPresenter">
                    <span v-if="data.selected_timeZone &&
                        data.selected_timeZone.label
                        " style="color: #00502e; font-weight: bold">{{ dataFormat(date, "DD MMMM Y") }}</span>
                </template>
                <template v-else>
                    <span style="color: #00502e; font-weight: bold">{{
                        dataFormat(date, "DD MMMM Y")
                    }}</span>
                </template>
                <!-- investor view -->
                <table v-if="!data.client.isPresenter" width="100%" id="dataTable" class="tableHead wid-on-mob"
                    style="border-spacing: 0px">
                    <thead>
                        <tr>
                            <th style="width: 15%"><b>Time</b></th>
                            <!-- <th style="width: 15%">
                                <b>Presenting Company</b>
                            </th> -->
                            <th style="width: 30%">
                                <b>Meeting Room Details</b>
                            </th>
                            <th style="width: 30%">
                                <b>Meeting Type</b>
                                <!-- <b>Representative(s)</b> -->
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(slot) in getPrivateMeetings(slots)" :key="slot.id" :data-id="slot.id">
                            <td style="width: 15%">
                                <span style="
                                                display: flex;
                                                margin-top: 4px;
                                                display: block;
                                            ">
                                    <img style="
                                                    margin-right: 4px;
                                                    width: 15px;
                                                    height: 15px;
                                                    margin-top: 3px;
                                                " :src="baseUrl +
                                                    '/assets/clock.jpg'
                                                    " alt="" />
                                    {{ slot.start_time }} -
                                    {{ slot.end_time }}</span>
                                <!-- <span
                                            v-if="
                                                data.selected_timeZone &&
                                                data.selected_timeZone.label
                                            "
                                            style="display: flex; margin: auto"
                                        >
                                            Time Zone:
                                            {{ data.selected_timeZone.label }}
                                        </span> -->
                            </td>

                            <!-- <td style="
                                vertical-align: top;
                                text-align: center;
                                width: 15%;
                            ">
                                <div>
                                    <img class="company_image" :src="`../../companies/${slot.company.name}.jpg`" alt="" />
                                </div>
                            </td> -->

                            <td>
                                <ul>
                                    <li style="margin-bottom: 0px">
                                        <b>
                                            {{
                                                slot.company
                                                ? slot.company.name
                                                : "No Company Exist"
                                            }}</b>
                                    </li>
                                    <!-- <li style="
                                            margin-bottom: 0px;
                                            font-weight: lighter;
                                        ">
                                        {{
                                            slot.name[
                                            slot.name.length - 1
                                            ] === "s"
                                            ? slot.name.substr(
                                                0,
                                                slot.name.length -
                                                1
                                            )
                                            : slot.name
                                        }}
                                    </li> -->
                                    <li style="margin-bottom: 0px">
                                        <span v-if="!data.conf.is_virtual &&
                                                slot.room &&
                                                (slot.room.room_number || slot.room_number)
                                                ">
                                            <span> RoomNo : </span>
                                            <a :href="data.conf.map_link
                                                " class="text_underline" target="_blank">
                                                (<span v-html="slot.room
                                                    .room_number || slot.room_number
                                                    "></span>)
                                            </a>
                                        </span>
                                        <span v-else>
                                            <span style="display: block" v-if="slot.room &&
                                                slot.room
                                                    .meeting_link
                                                ">
                                                <div>
                                                    Webex Room:
                                                    <a class="link_click" target="_blank" :href="slot.room
                                                        .meeting_link
                                                        ">CLICK HERE</a>
                                                </div>
                                                <div style="
                                                            padding-left: 10px;
                                                        ">
                                                    Meeting ID:
                                                    <span style="
                                                                font-weight: lighter;
                                                            ">
                                                        {{
                                                            slot.room
                                                                .meeting_id
                                                        }}
                                                    </span>
                                                </div>
                                                <div style="
                                                        padding-left: 10px;
                                                    ">
                                                    Password:
                                                    <span style="
                                                                font-weight: lighter;
                                                            ">
                                                        {{
                                                            slot.room
                                                                .meeting_password
                                                        }}
                                                    </span>
                                                </div>
                                                <!-- <div style="padding-left:10px" > Join by video system: <span style="font-weight:lighter"> {{ slot.room.sip }} </span> </div> -->
                                                <!-- <div> SIP: {{ slot.room.sip }} </div> -->
                                            </span>
                                        </span>
                                    </li>
                                </ul>
                            </td>

                            <td>
                                <ul>
                                    <li style="
                                            margin-bottom: 0px;
                                            font-weight: lighter;
                                        ">
                                        {{
                                            slot.name[
                                            slot.name.length - 1
                                            ] === "s"
                                            ? slot.name.substr(
                                                0,
                                                slot.name.length -
                                                1
                                            )
                                            : slot.name
                                        }}
                                    </li>
                                    <!-- <li style="font-weight: lighter" v-for="( presenter, index ) in 
                                        presentersSortedByJobTitle(slot.presenters)" :key="index">
                                        <img style="
                                                margin-right: 4px;
                                                width: 15px;
                                                margin-top: 3px;
                                            " :src="baseUrl +
                                                '/assets/person.png'
                                                " alt="" />
                                        {{
                                            presenter.full_titled_name
                                        }}; {{ presenter.job_title }}
                                    </li> -->
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <!-- presenter view -->
                <table v-if="data.client.isPresenter &&
                    data.selected_timeZone &&
                    data.selected_timeZone.label
                    " width="100%" id="dataTable" class="tableHead wid-on-mob" style="border-spacing: 0px">
                    <thead>
                        <tr>
                            <th style="width: 15%"><b>Time</b></th>
                            <th style="width: 25%">
                                <b>Meeting Details</b>
                            </th>
                            <th style="width: 30.1%">
                                <b> Investment Companies </b>
                            </th>
                            <!-- <th style="width: 40%">
                                <b>Representative</b>
                            </th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="slot in getPrivateMeetings(slots)" :key="slot.id">
                            <td style="width: 15%">
                                <span style="
                                                display: flex;
                                                margin-top: 4px;
                                            ">
                                    <img style="
                                                    margin-right: 4px;
                                                    width: 15px;
                                                    height: 15px;
                                                    margin-top: 3px;
                                                " :src="baseUrl +
                                                    '/assets/clock.jpg'
                                                    " alt="" />
                                    {{ slot.start_time }} -
                                    {{ slot.end_time }}</span>
                                <!-- <span
                                            v-if="
                                                data.selected_timeZone &&
                                                data.selected_timeZone.label
                                            "
                                            style="display: flex; margin: auto"
                                        >
                                            Time Zone:
                                            {{ data.selected_timeZone.label }}
                                        </span> -->
                            </td>
                            <td v-if="slot.type != 1">
                                <div style="font-weight: lighter">
                                    {{
                                        slot.name[
                                        slot.name.length - 1
                                        ] === "s"
                                        ? slot.name.substr(
                                            0,
                                            slot.name.length - 1
                                        )
                                        : slot.name
                                    }}
                                    <span v-if="!data.conf.is_virtual &&
                                            slot.room &&
                                            (slot.room.room_number || slot.room_number)
                                            ">
                                        <a :href="data.conf.map_link" class="text_underline" target="_blank">
                                            (<span v-html="slot.room
                                                .room_number || slot.room_number
                                                "></span>)
                                        </a>
                                    </span>
                                </div>
                                <div v-if="data.conf.is_virtual">
                                    <span style="display: block" v-if="slot.room &&
                                        slot.room.meeting_link
                                        ">
                                        <div>
                                            Webex Meeting Room:
                                            <a class="link_click" target="_blank" :href="slot.room
                                                .meeting_link
                                                ">CLICK HERE</a>
                                        </div>
                                        <div style="padding-left: 10px">
                                            Meeting ID:
                                            <span style="
                                                            font-weight: lighter;
                                                        ">{{
                                                            slot.room.meeting_id
                                                        }}
                                            </span>
                                        </div>
                                        <div style="padding-left: 10px">
                                            Password:
                                            <span style="
                                                            font-weight: lighter;
                                                        ">{{
                                                            slot.room
                                                                .meeting_password
                                                        }}
                                            </span>
                                        </div>
                                        <template v-if="slot.name ==
                                                'Strategy Meetings'
                                                ">
                                            <div style="
                                                            padding-left: 10px;
                                                        ">
                                                Join by video system:
                                                <span style="
                                                                font-weight: lighter;
                                                            ">
                                                    {{ slot.room.sip }}
                                                </span>
                                            </div>
                                            <div style="
                                                            padding-left: 10px;
                                                        ">
                                                Video System Password:
                                                <span style="
                                                                font-weight: lighter;
                                                            ">
                                                    {{
                                                        slot.room
                                                            .host_key
                                                    }}
                                                </span>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div style="
                                                            padding-left: 10px;
                                                        ">
                                                Host Key:
                                                <span style="
                                                                font-weight: lighter;
                                                            ">
                                                    {{
                                                        slot.room
                                                            .host_key
                                                    }}
                                                </span>
                                            </div>
                                            <div style="
                                                            padding-left: 10px;
                                                        ">
                                                Join by video system:
                                                <span style="
                                                                font-weight: lighter;
                                                            ">
                                                    {{ slot.room.sip }}
                                                </span>
                                            </div>
                                        </template>
                                    </span>
                                </div>
                            </td>
                            <td colspan="2" v-if="slot.type != 1">
                                <table style="width: 100%" cellpadding="0" cellspacing="0">
                                    <tr v-for="(
                                                    clients, company, index
                                                ) in slot.meetings" :key="index" style="margin-bottom: 20px">
                                        <td style="
                                                        width: 50%;
                                                        font-weight: lighter;
                                                    ">
                                            {{ index + 1 }}-
                                            {{ company }}
                                        </td>
                                        <!-- <td style="
                                                        width: 50%;
                                                        border-left: 1px solid
                                                            #555;
                                                    ">
                                            <table>
                                                <tr v-for="(
                                                                meetingClient,
                                                                    index
                                                            ) in clients" :key="index">
                                                    <td>
                                                        <div class="popup-wapper">
                                                            <span style="
                                                                            cursor: pointer;
                                                                            font-weight: lighter;
                                                                        ">
                                                                <img style="
                                                                                margin-right: 4px;
                                                                                width: 15px;
                                                                                margin-top: 3px;
                                                                            " :src="baseUrl +
                                                                                '/assets/person.png'
                                                                                " alt="" />
                                                                {{
                                                                    meetingClient
                                                                        .client
                                                                        .full_titled_name
                                                                }};
                                                                {{
                                                                    meetingClient
                                                                        .client
                                                                        .job_title
                                                                }}
                                                            </span>
                                                            <div class="popup-body" :id="'client' +
                                                                    meetingClient
                                                                        .client
                                                                        .id
                                                                    ">
                                                                <span style="
                                                                                font-weight: lighter;
                                                                            ">
                                                                    <strong>Email
                                                                        address:</strong>
                                                                    {{
                                                                        meetingClient
                                                                            .client
                                                                            .email
                                                                    }}
                                                                </span>
                                                                <span style="
                                                                                font-weight: lighter;
                                                                            ">
                                                                    <strong>Tel:</strong>
                                                                    {{
                                                                        meetingClient
                                                                            .client
                                                                            .telephone
                                                                    }}
                                                                </span>
                                                                <span style="
                                                                                font-weight: lighter;
                                                                            ">
                                                                    <strong>Biography:</strong>
                                                                    {{
                                                                        meetingClient
                                                                            .client
                                                                            .biography
                                                                    }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td> -->
                                    </tr>
                                </table>
                            </td>

                            <td style="width: 80%" v-if="slot.type == 1" colspan="3">
                                <!-- <span>Subject : {{ slot.name }}</span> -->
                                <p v-html="slot.description"></p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import Api from "@/Api";

var moment = require("moment");
var momentTZ = require("moment-timezone");

export default {
    name: "ProfileSchedule",
    data() {
        return {
            baseUrl: window.location.origin,
            pageIsDisable: false,
            error_message: "",
            data: {
                conf: {},
                schedule: [],
                client: {
                    isPresenter: false,
                    name: "",
                    company_name: "",
                    job_title: "",
                    formatted_name: "",
                },
                title: null,
                room_number: null,
                loaded: false,
                timeZones: [],
                selected_timeZone: { lable: "", code: "" },
            },
            // presenting_companies: [],
            // client: JSON.parse(localStorage.getItem("client")).client,
            // pageOpenDate: `${moment().format("l")} ${moment().format("LTS")}`,
            default_timezone: "Europe/London",
            // allowInvestorCancellationDate: null,
        };
    },
    methods: {
        getPageData() {
            Api()
                .get("auth/get-schedule")
                .then((response) => {
                    let data = response.data;
                    this.data.client.company = data.company;
                    this.data.client.isPresenter = data.isPresenter;
                    this.data.title = data.title;
                    this.data.conf = data.conf;
                    const confClient = data.conference_client;
                    // this.data.selected_timeZone = (confClient && confClient.timezone ) ? {label: confClient.timezone + " (GMT"+momentTZ.tz(confClient.timezone).format('Z')+")", code: confClient.timezone} : {label: '',code: ''};
                    if (data.isPresenter) {
                        this.data.room_number = data.room_number;
                        this.data.schedule = this.scheduleFormatter(
                            data.schedule
                        );
                    } else {
                        this.data.schedule = data.schedule;
                    }
                    if (this.data.schedule.length == 0) {
                        this.pageIsDisable = true;
                        this.error_message = "Schedule not prepared yet.";
                    }
                    this.changeTimeZone(
                        confClient && confClient.timezone
                            ? {
                                label:
                                    confClient.timezone +
                                    " (GMT" +
                                    momentTZ
                                        .tz(confClient.timezone)
                                        .format("Z") +
                                    ")",
                                code: confClient.timezone,
                            }
                            : {
                                label:
                                    this.default_timezone +
                                    " (GMT" +
                                    momentTZ
                                        .tz(this.default_timezone)
                                        .format("Z") +
                                    ")",
                                code: this.default_timezone,
                            }
                    );
                    this.data.loaded = true;
                })
                .catch((error) => {
                    this.data.loaded = true;
                    if (error) {
                        console.log(error);
                        if (error.response.status == 422) {
                            this.pageIsDisable = true;
                            var err = error.response.data;
                            this.errors = err.errors;
                        } else if (error.response.status == 401) {
                            this.$store.dispatch("logout");
                            this.$router.push({
                                name: "login",
                                query: {
                                    redirect:
                                        this.$router.currentRoute.fullPath,
                                },
                            });
                            //   this.$router.push('login')

                            // setTimeout(e => this.getPageData(), 5000)
                        }
                    }
                });
        },
        scheduleFormatter(schedules) {
            var newScheduleFormat = [];
            for (var date in schedules) {
                let slots = schedules[date];
                let newSlots = slots.map((slot) => {
                    slot.meetings = _.groupBy(
                        slot.meetings,
                        (meeting) => meeting.client.company.name
                    );
                });
            }
            return schedules;
        },
        convertTimeZone(date, oldTimeZone, newTimeZone) {
            const time = momentTZ.tz(date, oldTimeZone);
            const oldTime = time.format("L");
            time.tz("Asia/Saudi Arabia");
            const londonTime = time.format("L");
            time.tz(newTimeZone);
            const newTime = time.format("L");
            const diff = moment(newTime).diff(moment(londonTime), "days");
            let res = time.format("HH:mm");
            if (diff) {
                res += "(" + (diff > 0 ? "+" : "") + diff + ")";
            }
            return res;
        },
        changeTimeZone({ code, label }) {
            Object.keys(this.data.schedule).forEach((date) => {
                this.data.schedule[date] = this.data.schedule[date].map(
                    (slot) => {
                        const startTime = slot.start_time.replace(/\(.+\)/, "");
                        const end_time = slot.end_time.replace(/\(.+\)/, "");
                        slot.start_time = this.convertTimeZone(
                            `${slot.date} ${startTime}`,
                            this.data.selected_timeZone.code ||
                            this.default_timezone,
                            code
                        );
                        slot.end_time = this.convertTimeZone(
                            `${slot.date} ${end_time}`,
                            this.data.selected_timeZone.code ||
                            this.default_timezone,
                            code
                        );
                        return slot;
                    }
                );
            });
            this.data.selected_timeZone.code = code;
            this.data.selected_timeZone.label = label;
        },
        getPrivateMeetings(slots) {
            return slots.filter((slot) => slot.type != 1);
        },
        hasPrivateMeetings(slots) {
            return this.getPrivateMeetings(slots).length > 0;
        },
        dataFormat(data, format) {
            return moment(data).format(format);
        },
        presentersSortedByJobTitle(presenters) {
            return _.orderBy(presenters, "job_title");
        },
    },
    mounted() {
        this.getPageData();
    }
};
</script>

<style>
.my-border {
    border: 1px solid #ddd;
    padding: 0.5rem;
}

.tableHead>thead>tr {
    width: 100%;
    page-break-inside: avoid;
    page-break-before: auto;
}

.tableHead>thead>tr>th {
    border: 1px solid gray;
    padding-left: 1%;
    background-color: #00502e;
    height: 40px;
    color: #fff;
    width: 20%;
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
    font-family: Calibri;
}

.tableHead>tbody>tr {
    width: 100%;
    color: black;
    page-break-inside: avoid;
    page-break-before: auto;
}

.tableHead>tbody>tr>td {
    border: 1px solid gray;
    font-weight: bold;
    vertical-align: top;
    padding-left: 1%;
    padding-right: 1%;
    width: 20%;
    font-family: Calibri;
    font-size: 14px;
}

.tableHead>tbody>tr>td>table tr td:nth-child(2) {
    padding-left: 1%;
}

.tableHead>tbody>tr>td>span {
    display: inline-block;
    width: 98%;
}

.tableHead>tbody>tr:nth(1) {
    border: 1px solid gray;
    font-weight: bold;
    vertical-align: top;
    padding-left: 1%;
    width: 20%;
    font-family: Calibri;
    font-size: 14px;
}

.company_image {
    max-width: 130px;
    max-height: 100px;
    object-fit: contain;
    border-radius: 2px;
    margin-top: 10px;
}
</style>